import {
	COLOR_LABEL_TEXT,
	COLOR_PLACEHOLDER,
	COLOR_RPG_BACKGROUND,
	COLOR_RPG_TEXT,
} from 'constants/color';
import {
	SIZE_FONT_BASE,
	WIDTH_SERIF_FRAME,
	vw,
	PADDING_RPG_FRAME,
	SIZE_BORDER,
} from 'constants/size';
import { getFontFamily } from 'hooks/useFonts';
import React, { useEffect, useRef } from 'react';
import { StyleSheet, Text, TextInput, View } from 'react-native';

type Props = {
	values: {
		name: string;
		job: string;
		sex: string;
		serif: string;
	};
	placeholders: {
		name: string;
		job: string;
		sex: string;
		serif: string;
	};
	onChanges: {
		name: (value: string) => void;
		job: (value: string) => void;
		sex: (value: string) => void;
		serif: (value: string) => void;
	};
};

const PADDING = PADDING_RPG_FRAME + SIZE_BORDER;

const styles = StyleSheet.create({
	container: {
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
	},
	textLabel: {
		fontFamily: getFontFamily('dq'),
		fontSize: SIZE_FONT_BASE * 0.8,
		color: COLOR_LABEL_TEXT,
		marginBottom: 8,
	},
	textInput: {
		fontFamily: getFontFamily('dq'),
		fontSize: SIZE_FONT_BASE,
		color: COLOR_RPG_TEXT,
		backgroundColor: COLOR_RPG_BACKGROUND,
		width: vw / 2,
		paddingBottom: SIZE_FONT_BASE * 0.5,
	},
	statusTextInput: {
		width: WIDTH_SERIF_FRAME,
		paddingHorizontal: PADDING,
	},
	serifTextInput: {
		width: WIDTH_SERIF_FRAME,
		height: SIZE_FONT_BASE * 4 + SIZE_FONT_BASE * 0.5,
		textAlignVertical: 'top',
		paddingHorizontal: PADDING,
	},
});

const EditPresenter: React.VFC<Props> = ({
	values,
	placeholders,
	onChanges,
}) => {
	const nameRef = useRef<TextInput>(null);
	const jobRef = useRef<TextInput>(null);
	const sexRef = useRef<TextInput>(null);
	const serifRef = useRef<TextInput>(null);

	useEffect(() => {
		nameRef.current?.focus();
	}, []);

	return (
		<View style={styles.container}>
			<View>
				<Text style={styles.textLabel}>なまえ：</Text>
				<TextInput
					ref={nameRef}
					style={[styles.textInput, styles.statusTextInput]}
					value={values.name}
					onChangeText={onChanges.name}
					placeholder={placeholders.name}
					placeholderTextColor={COLOR_PLACEHOLDER}
					onSubmitEditing={() => {
						jobRef.current?.focus();
					}}
				/>
			</View>
			<View>
				<Text style={styles.textLabel}>しょくぎょう：</Text>
				<TextInput
					ref={jobRef}
					style={[styles.textInput, styles.statusTextInput]}
					value={values.job}
					onChangeText={onChanges.job}
					placeholder={placeholders.job}
					placeholderTextColor={COLOR_PLACEHOLDER}
					onSubmitEditing={() => {
						sexRef.current?.focus();
					}}
				/>
			</View>
			<View>
				<Text style={styles.textLabel}>せいべつ：</Text>
				<TextInput
					ref={sexRef}
					style={[styles.textInput, styles.statusTextInput]}
					value={values.sex}
					onChangeText={onChanges.sex}
					placeholder={placeholders.sex}
					placeholderTextColor={COLOR_PLACEHOLDER}
					onSubmitEditing={() => {
						serifRef.current?.focus();
					}}
				/>
			</View>
			<View>
				<Text style={styles.textLabel}>セリフ：</Text>
				<TextInput
					ref={serifRef}
					style={[styles.textInput, styles.serifTextInput]}
					value={values.serif}
					onChangeText={onChanges.serif}
					multiline={true}
					placeholder={placeholders.serif}
					placeholderTextColor={COLOR_PLACEHOLDER}
				/>
			</View>
		</View>
	);
};

export default EditPresenter;
